"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

// Hook to return current device based on theme breakpoints
var windowBreakpoints = [{
  device: "MOBILE",
  width: 768
}, {
  device: "TABLET",
  width: 1024
}];

var useClientDevice = function useClientDevice() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  var getDevice = function getDevice() {
    var d; // Set window width/height to state
    // Checks width against devices

    if (typeof window !== "undefined") {
      var _windowBreakpoints$fi;

      d = (_windowBreakpoints$fi = windowBreakpoints.find(function (breakPoint) {
        return window.innerWidth <= breakPoint.width;
      })) == null ? void 0 : _windowBreakpoints$fi.device;
    }

    return d || "DESKTOP";
  };

  var _useState = (0, _react.useState)(getDevice()),
      device = _useState[0],
      setDevice = _useState[1];

  (0, _react.useEffect)(function () {
    var setterFunction = function setterFunction() {
      return setDevice(getDevice());
    }; // Add event listener


    if (typeof window !== "undefined") window.addEventListener("resize", setterFunction); // Call handler right away so state gets updated with initial window size

    setDevice(getDevice()); // Remove event listener on cleanup

    return function () {
      return window.removeEventListener("resize", setterFunction);
    };
  }, []); // Empty array ensures that effect is only run on mount

  return device;
};

var _default = useClientDevice;
exports["default"] = _default;